import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';
import { ref } from 'vue';

export const useKeyboardDetect = () => {
  const keyboardVisible = ref(false);

  if (Capacitor.isNativePlatform()) {
    Keyboard.addListener('keyboardWillShow', (info) => {
      keyboardVisible.value = true;

      if (Capacitor.getPlatform() === 'android') {
        document.documentElement.style.setProperty(
          '--ion-keyboard-height',
          `${info.keyboardHeight}px`,
        );
      }
    });

    Keyboard.addListener('keyboardWillHide', () => {
      keyboardVisible.value = false;

      if (Capacitor.getPlatform() === 'android') {
        document.documentElement.style.setProperty(
          '--ion-keyboard-height',
          `0px`,
        );
      }
    });
  }

  return {
    keyboardVisible,
  };
};
